import { render } from "./MenuBody.vue?vue&type=template&id=8d42ae5a&scoped=true"
import script from "./MenuBody.vue?vue&type=script&lang=js"
export * from "./MenuBody.vue?vue&type=script&lang=js"

import "./MenuBody.vue?vue&type=style&index=0&id=8d42ae5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d42ae5a"]])

export default __exports__